import styled from 'styled-components';

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	height: 609px;
	overflow-y: scroll;
	width: 380px;
	margin-top: 30px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledSettingsContainer };
